import { render, staticRenderFns } from "./TableBGMesurementV3.vue?vue&type=template&id=1881025a&scoped=true"
import script from "./TableBGMesurementV3.vue?vue&type=script&lang=js"
export * from "./TableBGMesurementV3.vue?vue&type=script&lang=js"
import style0 from "./TableBGMesurementV3.vue?vue&type=style&index=0&id=1881025a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1881025a",
  null
  
)

export default component.exports